import React from 'react';
import { Dialog, Grid, IconButton } from 'src/components';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch } from 'src/store';
import { RedPanikSlice } from 'src/store/Slices/RedPanik/RedPanikSlice';
import RedPanikHastaList from './RedPanikHastaList';
import RedPanikIslemList from './RedPanikIslemList';

interface IRedPanikProps {
    open: boolean;
}
const translatePath = "pages|redPanik";
const RedPanik = (props: IRedPanikProps): JSX.Element => {
    const { open } = props;
    const dispatch = useAppDispatch();

    const handlerClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(RedPanikSlice.actions.setOpen(false));
    }
    return (
        <Dialog fullWidth open={open} maxWidth="lg">
            <DialogTitle>
                {translate(translatePath, "Red Panik")}
                <IconButton
                    customType="close"
                    onClick={handlerClose}
                    sx={{
                        padding: 0,
                        margin: 0,
                        zIndex: 999999999999,
                        display: "block",
                        height: "24px",
                        width: "24px",
                        borderRadius: "25px",
                        textAlign: "center",
                        position: "fixed",
                        top: "5px",
                        right: "5px"
                    }}
                />
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item lg={4}>
                        <RedPanikHastaList />
                    </Grid>
                    <Grid item lg={8}>
                        <RedPanikIslemList />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default RedPanik;